import React from 'react';
import { Screen } from '../App/Screen';

export function NotAuthorised() {
    return (
        <Screen title="Not Authorised">
            <p>You are not authorised to view this page</p>
        </Screen>
    );
}